import React, { useState } from 'react'
import PropTypes from 'prop-types'
import './VerticalTabs.scss'

const VerticalTabs = ({
  data,
  valueKey = '',
  title = '',
  className = '',
  onTabChange = () => {},
}) => {
  const [internalActiveTabIndex, setInternalActiveTabIndex] = useState(0)

  const handleTabClick = (index) => {
    setInternalActiveTabIndex(index)
    onTabChange(index)
  }

  return (
    <div className={`vertical-tabs-layout ${className}`}>
      <div className="tabs-panel">
        <div className="tabs-header">
          <h3>{title}</h3>
        </div>
        <div className="tabs-list">
          {data.map((item, index) => (
            <button
              key={item[valueKey]}
              className={`single-tab-btn ${internalActiveTabIndex === index ? 'active' : ''}`}
              onClick={() => handleTabClick(index)}
              type="button"
            >
              <span className="single-tab-value">{item[valueKey]}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}

VerticalTabs.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired, // title of the vertical tabs component
  valueKey: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  onTabChange: PropTypes.func,
}

export default VerticalTabs
